<template>
  <div class="popin-shared" :class="{ organization: organizationMembers }">
    <p v-if="workspace === workspaceTypes.shared">
      {{ $t('dashboard.sharedPopin.sharedBy') }}
    </p>
    <div v-if="workspace === workspaceTypes.shared" class="collab-name">
      {{ sharedInformation.sharer }}
    </div>
    <p v-if="organizationMembers">
      {{
        sharedInformation.collabos.length > 1
          ? sharedInformation.collabos.length + $t('dashboard.sharedPopin.member.plural')
          : sharedInformation.length + $t('dashboard.sharedPopin.member.plural')
      }}
    </p>
    <p v-else>
      {{ $t('dashboard.sharedPopin.sharedWith') }}
      {{
        sharedInformation.collabos.length > 1
          ? sharedInformation.collabos.length + $t('dashboard.sharedPopin.person.plural')
          : sharedInformation.collabos.length + $t('dashboard.sharedPopin.person.singular')
      }}
    </p>
    <div
      v-for="(collabo, i) in collaborators"
      :key="`${collabo.id}+${i}`"
      class="collab-name"
      :class="{ email: !collabo.firtname && !collabo.lastname }"
    >
      {{ !collabo.firtname && !collabo.lastname ? collabo.email : `${collabo.firstname} ${collabo.lastname}` }}
    </div>
  </div>
</template>

<script>
import enums from '@/helpers/enums';

export default {
  name: 'ShareTooltip',
  props: {
    organizationMembers: {
      type: Boolean,
      default: false,
    },
    workspace: {
      type: Number,
      default: 0,
    },
    sharedInformation: {
      type: Object,
      default: () => {},
    },
    collaborators: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      workspaceTypes: enums.workspaceTypes,
    };
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/popins.scss';
</style>
